export default __webpack_public_path__ + "static/media/132.460326af.jpg";